import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue';
import useI18n from '@/mixins/useI18n';
import { LETTER_WEEKDAYS } from '@/models/DateTime';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXDatePickerMonth',
  props: {
  month: {
    type: Number,
    required: true,
  },
  year: {
    type: Number,
    required: true,
  },
  selectedDate: {
    type: Date as PropType<Date>,
    required: true
  },
  earliestDate: {
    type: Date as PropType<Date>,
    required: true
  },
  latestDate: {
    type: Date as PropType<Date>,
    required: true
  },
  dimBeforeDate: {
    type: Date as PropType<Date | null>,
    default: null
  },
  hasDot: {
    type: Function as PropType<(date: Date) => boolean>,
    default: null
  }
},
  emits: ['select-date'],
  setup(__props, { emit }) {

const props = __props;

const { locale } = useI18n();

const WEEK_BEGIN = 1;

const weekdayLetters = computed(() => {
  let i = WEEK_BEGIN;
  const days = [...LETTER_WEEKDAYS[locale.value]];
  while (i--) {
    days.push(days.shift());
  }
  return days;
});




const weekdayOffset = computed(() => (new Date(props.year, props.month, 1 - WEEK_BEGIN)).getDay());
const numDays = computed(() => new Date(props.year, props.month + 1, 0).getDate());
const trailingDays = computed(() => Math.max(0, 42 - weekdayOffset.value - numDays.value));

const monthAndYearDifference = (date: Date) => {
  const totalMonths = (date.getFullYear() * 12) + date.getMonth();
  const totalCurrentMonths = (props.year * 12) + props.month;
  return totalCurrentMonths - totalMonths;
};

const getBoundaryDayForCurrentMonth = (date: Date) => {
  const diff = monthAndYearDifference(date);
  if (!diff) return date.getDate();
  return diff < 0 ? 35 : -1;
};

const earliestDay = computed(() => getBoundaryDayForCurrentMonth(props.earliestDate));
const latestDay = computed(() => getBoundaryDayForCurrentMonth(props.latestDate));
const dimBeforeDay = computed(() => (props.dimBeforeDate ? getBoundaryDayForCurrentMonth(props.dimBeforeDate) : -1));
const selectedDay = computed(() => (!monthAndYearDifference(props.selectedDate) ? props.selectedDate.getDate() : -1));

const onSelectDate = (day: number) => {
  const date = new Date(Date.UTC(props.year, props.month, day));
  emit('select-date', date);
};


return { __sfc: true,locale, WEEK_BEGIN, weekdayLetters, props, emit, weekdayOffset, numDays, trailingDays, monthAndYearDifference, getBoundaryDayForCurrentMonth, earliestDay, latestDay, dimBeforeDay, selectedDay, onSelectDate }
}

})